import type { ProjectStorage } from '../storage/ProjectStorage';
import type { AppMode } from '../types';

export const loadLastSessionFromStorage = async (options: {
  storageKey: string;
  getStorage: () => ProjectStorage | null;
  getMode: () => AppMode;
  loadProject: (id: string) => Promise<void>;
  switchMode: (mode: AppMode, preserveCurrentState?: boolean) => void;
}): Promise<void> => {
  const lastSessionData = localStorage.getItem(options.storageKey);
  if (!lastSessionData) return;

  try {
    const session = JSON.parse(lastSessionData) as {
      projectId: string | null;
      mode: AppMode;
    };

    if (session.projectId) {
      const storage = options.getStorage();
      if (!storage) return;
      const project = await storage.getProject(session.projectId);
      if (!project) {
        localStorage.removeItem(options.storageKey);
        return;
      }

      await options.loadProject(session.projectId);
    }

    if (session.mode !== options.getMode()) {
      // Pass false to prevent overwriting the loaded project's mode states
      options.switchMode(session.mode, false);
    }
  } catch {
    localStorage.removeItem(options.storageKey);
  }
};
